import 'src/assets/styles/declarations/_index.module.scss';
import 'src/assets/styles/declarations/font-faces.css';
import './languages/i18n';

import React from 'react';

import { ApolloProvider } from '@apollo/client';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { ConnectedRouter } from 'connected-react-router';
import mapboxgl from 'mapbox-gl';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { client } from 'src/apollo-client';
import { ApplicationContextProvider } from 'src/contexts/ApplicationContext';
import { history, persistor, store, useAppDispatch } from 'src/redux/store';

import App from './App';

// Bugfix for: https://github.com/mapbox/mapbox-gl-js/issues/10173
// @ts-ignore
// eslint-disable-next-line @typescript-eslint/no-var-requires
mapboxgl.workerClass = require('worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker').default;

function WithApollo() {
  const dispatch = useAppDispatch();

  return (
    <ApolloProvider client={client(dispatch)}>
      <ConnectedRouter history={history}>
        <ApplicationContextProvider>
          <App />
        </ApplicationContextProvider>
      </ConnectedRouter>
    </ApolloProvider>
  );
}

const GOOGLE_OAUTH_CLIENT_ID =
  '1013094782402-etppmnp8oihpiiopsj1i4gkq6ciboo8g.apps.googleusercontent.com';

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <GoogleOAuthProvider clientId={GOOGLE_OAUTH_CLIENT_ID}>
          <WithApollo />
        </GoogleOAuthProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>,
  document.getElementById('app-root'),
);
